import React, { useState } from 'react';
import './VendorManagement.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const getAuthHeaders = (headers = {}) => {
  const token = localStorage.getItem('authToken');
  return token ? { ...headers, Authorization: `Bearer ${token}` } : headers;
};

const formatAmount = (value, currency = 'EUR') => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  const amount = Number(value);
  if (Number.isNaN(amount)) {
    return String(value);
  }

  return `${amount.toFixed(2)} ${currency}`;
};

const EngineUniqueAnalysis = () => {
  const [searchType, setSearchType] = useState('');
  const [activeType, setActiveType] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingResults, setLoadingResults] = useState(false);
  const [error, setError] = useState(null);
  const [summary, setSummary] = useState(null);

  const loadResults = async (typeMoteur) => {
    setLoadingResults(true);
    setError(null);

    try {
      const params = new URLSearchParams({ typeMoteur, limit: '200' });
      const response = await fetch(`${API_BASE_URL}/engine-analysis/list/results?${params.toString()}`, {
        headers: getAuthHeaders(),
      });
      const data = await response.json();

      if (!response.ok || data.success === false) {
        throw new Error(data.error || 'Erreur lors du chargement des resultats');
      }

      setRows(data.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingResults(false);
    }
  };

  const handleRunAnalysis = async () => {
    const normalizedType = searchType.trim();

    if (!normalizedType) {
      setError('Renseignez un type moteur');
      return;
    }

    setLoading(true);
    setError(null);
    setSummary(null);

    try {
      const response = await fetch(`${API_BASE_URL}/engine-analysis/list/run`, {
        method: 'POST',
        headers: getAuthHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
          typeMoteur: normalizedType,
          maxResults: 200,
        }),
      });
      const data = await response.json();

      if (!response.ok || data.success === false) {
        throw new Error(data.error || 'Erreur lors du lancement de la veille moteur');
      }

      setSummary(data);
      setActiveType(normalizedType);
      await loadResults(normalizedType);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vendor-management">
      <h2>Veille Marche Moteur - Analyse unique</h2>

      {error && <div className="error-message">{error}</div>}

      <div className="search-bar">
        <input
          type="text"
          value={searchType}
          onChange={(e) => setSearchType(e.target.value)}
          placeholder="Saisir un type moteur..."
          disabled={loading || loadingResults}
        />

        <button
          className="btn btn-primary"
          onClick={handleRunAnalysis}
          disabled={loading || !searchType.trim()}
        >
          {loading ? 'Analyse en cours...' : 'Lancer la veille'}
        </button>
      </div>

      {summary && (
        <div className="search-section" style={{ textAlign: 'left' }}>
          <h3>Resume de synchronisation</h3>
          <p>Requete: {summary.query}</p>
          <p>Type moteur recherche: {activeType}</p>
          <p>Items Browse API: {summary.summaryCount}</p>
          <p>Items gardes (titre commence par Moteur): {summary.matchedCount}</p>
          <p>Details mis a jour: {summary.detailUpdatedCount}</p>
          <p>Erreurs: {summary.errorCount}</p>
        </div>
      )}

      {loadingResults ? (
        <div className="loading">Chargement des resultats...</div>
      ) : (
        <div className="vendors-list">
          {rows.length === 0 ? (
            <p className="no-data">
              {activeType ? 'Aucune donnee stockee pour ce type moteur' : 'Lancez une analyse pour afficher des resultats'}
            </p>
          ) : (
            <table className="vendors-table">
              <thead>
                <tr>
                  <th>Item ID</th>
                  <th>Titre</th>
                  <th>Vendeur</th>
                  <th>Code moteur</th>
                  <th>KM</th>
                  <th>Prix</th>
                  <th>Port</th>
                  <th>Stock</th>
                  <th>Lien</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.itemId}>
                    <td>{row.itemId}</td>
                    <td>{row.title}</td>
                    <td>{row.sellerName || '-'}</td>
                    <td>{row.codeMoteur || '-'}</td>
                    <td>{row.kilometers ? `${row.kilometers} km` : '-'}</td>
                    <td>{formatAmount(row.price, row.currency)}</td>
                    <td>{formatAmount(row.shippingCost, row.currency)}</td>
                    <td>{row.availableQuantity ?? '-'}</td>
                    <td>
                      {row.itemWebUrl ? (
                        <a href={row.itemWebUrl} target="_blank" rel="noopener noreferrer">
                          Ouvrir
                        </a>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};

export default EngineUniqueAnalysis;
